import * as React from 'react';
import { colors } from '../../../index';

const IconPaint = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 15 15",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.16 7.58L7.4 3.83a.31.31 0 00-.44 0L5.72 5.08a.31.31 0 000 .44l3.75 3.75a.31.31 0 00.44 0l1.25-1.25a.31.31 0 000-.44zM4.9 9.14a.31.31 0 00-.43 0l-1.51 1.51c-.3.3-.46.7-.46 1.1v.43a.31.31 0 00.62 0v-.42c0-.25.1-.49.28-.66l1.5-1.51a.31.31 0 000-.45zM14.36.63a2.24 2.24 0 00-3.1 0L8.24 3.79l2.97 2.97 3.15-3.03a2.17 2.17 0 000-3.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17 8.86c-1.1 1.06-3.2 3.1-4.01 3.96a.92.92 0 01-.68.3h-.29c-.3 0-.6.09-.87.26l-1.34.9L.7 14l.9-1.34c.17-.26.26-.56.26-.87v-.35c0-.26.1-.5.28-.67L6.11 6.8l-.44-.44-3.97 3.97c-.3.3-.46.69-.46 1.1v.36c0 .19-.05.36-.16.52L.05 13.88a.31.31 0 00.04.4l.63.62a.31.31 0 00.4.04l1.55-1.04c.16-.1.33-.16.52-.16h.29c.43 0 .84-.18 1.13-.49.8-.85 2.91-2.9 4-3.95l-.44-.44z"
  }));
};

export default IconPaint;